export default {
  onlyWasteArray(context, objectFromWaste){
    context.commit("setWaste", objectFromWaste);
  }
}